import { useEffect, useState } from "react";
import { Loader2, Target } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export default function BudgetEditor() {
  const [goal, setGoal] = useState("");
  const [limits, setLimits] = useState({});
  const [categories, setCategories] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data.expense));
    api.get("/budget").then((r) => {
      setGoal(r.data.savings_goal ? String(r.data.savings_goal) : "");
      setLimits(Object.fromEntries(Object.entries(r.data.limits).map(([k, v]) => [k, String(v)])));
    });
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/budget", {
        savings_goal: parseFloat(goal) || 0,
        limits: Object.fromEntries(Object.entries(limits).filter(([, v]) => parseFloat(v) > 0)),
      });
      toast.success("Bütçe ayarları kaydedildi");
    } catch {
      toast.error("Kaydedilemedi");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-card border border-border rounded-2xl p-6 space-y-5" data-testid="budget-editor">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-primary/15 flex items-center justify-center">
          <Target className="w-5 h-5 text-primary" />
        </div>
        <div>
          <h2 className="font-heading text-lg font-semibold">Bütçe & Hedef</h2>
          <p className="text-xs text-muted-foreground">Aylık tasarruf hedefi ve kategori bazlı harcama limitleri</p>
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="savings-goal">Aylık Tasarruf Hedefi (₺)</Label>
        <Input id="savings-goal" data-testid="savings-goal-input" type="number" min="0" step="0.01"
          placeholder="Örn: 5000" value={goal} onChange={(e) => setGoal(e.target.value)} />
      </div>

      <div className="space-y-3">
        <Label>Kategori Harcama Limitleri (₺/ay)</Label>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {categories.map((c) => (
            <div key={c} className="flex items-center gap-2">
              <span className="text-sm text-muted-foreground w-28 shrink-0 truncate">{c}</span>
              <Input data-testid={`budget-limit-input-${c}`} type="number" min="0" step="0.01" placeholder="Limit yok"
                value={limits[c] || ""} onChange={(e) => setLimits({ ...limits, [c]: e.target.value })} />
            </div>
          ))}
        </div>
      </div>

      <Button data-testid="budget-save-button" onClick={save} disabled={saving} className="rounded-full font-semibold">
        {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Kaydet
      </Button>
    </div>
  );
}
